export const checkRole = () => {
  const tokenJson = localStorage.getItem('ccAdmin.currentUser');
  if (tokenJson) {
    try {
      const token = JSON.parse(tokenJson).token;
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

      // Добавляем недостающие знаки "=" для корректной длины
      const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');

      const decodedTokenJson = atob(padded);
      return JSON.parse(decodedTokenJson).roles;
    } catch (error) {
      console.error('Ошибка при декодировании токена:', error);
      return null;
    }
  }

  return null;
};
